export default __webpack_public_path__ + "static/media/drupal-negative.75fc3e80.svg";